import ReportCellRenderer from './ReportCellRenderer';
import ReportNumeralCellRenderer from './ReportNumberCellRenderer';
import { suppressAnyKeyboardEventInEdition } from './helpers';
import ReportCellTruncatedRenderer from './ReportCellTruncatedRenderer';

const valueSetter = params => {
  const oldValue = params.oldValue?.data?.value;
  const newValue = params.newValue?.data?.value;
  if (params.newValue?.validationFailed) {
    return false;
  }

  if (oldValue === newValue) {
    return false;
  }

  params.oldValue = {
    ...params.newValue,
  };

  return true;
};

const gridCellDefinition = {
  suppressHeaderMenuButton: true,
  menuTabs: [],
};

export const gridNameCellDefinition = {
  ...gridCellDefinition,
  width: 340,
  minWidth: 340,
  cellRenderer: ReportCellTruncatedRenderer,
};

export const gridNumeralCellDefinition = {
  ...gridCellDefinition,
  width: 100,
  minWidth: 100,
  cellRenderer: ReportNumeralCellRenderer,
  valueSetter,
  cellEditor: 'cellEditor',
  suppressKeyboardEvent: suppressAnyKeyboardEventInEdition,
};

export const gridTextCellDefinition = {
  ...gridCellDefinition,
  width: 100,
  minWidth: 100,
  cellRenderer: ReportCellRenderer,
};
